import { render } from "./CampaignForm.vue?vue&type=template&id=5edbd33a&scoped=true&ts=true"
import script from "./CampaignForm.vue?vue&type=script&lang=ts"
export * from "./CampaignForm.vue?vue&type=script&lang=ts"

import "./CampaignForm.vue?vue&type=style&index=0&id=5edbd33a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5edbd33a"]])

export default __exports__